import '..//..//..//mixins.js'
import Accordion from "../../Accordion.vue"


export default {
  name: 'settings-portfolio',
  components: {
    Accordion
  },
  props: [],
  data () {
    return {
      isModalVisible: false,
      isAccordionVisible: false,
      isOpen: false,
      isShareable: true,
      copySuccessful: false,
      copyFailed: false,
      shareableUrl: "",
      shareData: [],
      isSettingsSubSuccessful: false,
      portfolio_id : this.$route.params.PORTFOLIO_ID,

    }
  },
  computed: {
    /*accordionClasses: function() {
      return {
        'is-closed': !this.isOpen,
        'is-primary': this.isOpen,
        'is-dark': !this.isOpen
      };
    }*/
  },
  async mounted () {
    //await this.updateData();

  },
  methods: {

    updateData: async function() {
     
      //this.responseData = await this.accessEndpoint('https://private-5c67a-optifolio.apiary-mock.com/settings');
      //this.boxes = this.responseData;
      //this.backendResponse = await this.accessEndpoint('userSettings/?format=json&username=testuser');
      //this.boxes = this.backendResponse[0];

},
    async showModal() {
            try{
        this.shareableUrl = await this.accessEndpoint('sharedPortfolioLink/?format=json&portfolio_id=' + this.portfolio_id)
        this.isShareable = true;
      }
      catch{
        console.log("false")
        this.isShareable = false;
      }
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    closeModalAndSubmit(){
      var filter = this.getCheckedInputs(["assets", "risk_types", "countries", "sectors", "models", "brokers"]); // post this to API Query
      console.log(filter);
      this.updateSettings();
      this.isModalVisible = false;
    },
    clickAccordion() {
      this.isAccordionVisible =! this.isAccordionVisible;
    },
    toggleAccordion: function() {
      this.isOpen = !this.isOpen;
    },
    showSuccessfulNotification: function(){
      setTimeout(() => this.copySuccessful = true, 200)
      setTimeout(() => this.copySuccessful = false, 3000)
    },
    showFailedNotification: function(){
      setTimeout(() => this.copyFailed = true, 200)
      setTimeout(() => this.copyFailed = false, 2000)
    },
    copyToClipboard () {
      let copyClipboard = document.querySelector('#link-box')
      copyClipboard.setAttribute('type', 'text')
      copyClipboard.select()

      try {
        var successful = document.execCommand('copy');
        successful ? this.showSuccessfulNotification() : this.showFailedNotification();
      } catch (err) {
        this.showFailedNotification();
      }
      window.getSelection().removeAllRanges()
    },
    onChangeEventHandler: async function (){
      if(this.isShareable){
        this.shareData = {
          "portfolio_id": this.portfolio_id,
          "shared_status": 1
        }
      }else{
        this.shareData = {
          "portfolio_id": this.portfolio_id,
          "shared_status": 0
        }
        console.log("not true")
        console.log(this.isShareable)
      }
      let test = await this.putEndpoint(this.shareData,'changeShareStatus/')
      console.log(test)
      if(this.isShareable){
        this.shareableUrl = await this.accessEndpoint('sharedPortfolioLink/?format=json&portfolio_id=' + this.portfolio_id)
      }else{
        this.shareableUrl = ""
      }

    }
  }
}


